/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FufiFinancialInfoPremiumStatus = {
    Unpaid: 'Unpaid',
    PartiallyPaid: 'PartiallyPaid',
    FullyPaid: 'FullyPaid',
    Unknown: 'Unknown'
} as const;
export type FufiFinancialInfoPremiumStatus = typeof FufiFinancialInfoPremiumStatus[keyof typeof FufiFinancialInfoPremiumStatus];


export function instanceOfFufiFinancialInfoPremiumStatus(value: any): boolean {
    for (const key in FufiFinancialInfoPremiumStatus) {
        if (Object.prototype.hasOwnProperty.call(FufiFinancialInfoPremiumStatus, key)) {
            if (FufiFinancialInfoPremiumStatus[key as keyof typeof FufiFinancialInfoPremiumStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FufiFinancialInfoPremiumStatusFromJSON(json: any): FufiFinancialInfoPremiumStatus {
    return FufiFinancialInfoPremiumStatusFromJSONTyped(json, false);
}

export function FufiFinancialInfoPremiumStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): FufiFinancialInfoPremiumStatus {
    return json as FufiFinancialInfoPremiumStatus;
}

export function FufiFinancialInfoPremiumStatusToJSON(value?: FufiFinancialInfoPremiumStatus | null): any {
    return value as any;
}

export function FufiFinancialInfoPremiumStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): FufiFinancialInfoPremiumStatus {
    return value as FufiFinancialInfoPremiumStatus;
}

